<template>
  <div class="site-success">
    <h2 class="text-center">{{ message }}</h2>
  </div>
</template>
<script>
import mainMixin from '../mixins/mainMixin'

export default {
  name: 'SuccessPage',
  mixins: [
    mainMixin
  ],

  props: {
    message: {
      type: String,
      default: 'Успешно'
    }
  }
}
</script>
